import script from "./wiser-icons.vue?vue&type=script&setup=true&lang=js"
export * from "./wiser-icons.vue?vue&type=script&setup=true&lang=js"

import "./wiser-icons.vue?vue&type=style&index=0&id=74dc0f32&scope=true&lang=scss"

const __exports__ = script;

export default __exports__